import React from 'react';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const YoutubeLink = ({
  title,
  youtubeId
}) => /*#__PURE__*/_jsx("span", {
  className: style.videoContainer,
  children: /*#__PURE__*/_jsx("iframe", {
    allowFullScreen: true,
    title: title || "YouTube video ".concat(youtubeId),
    src: "https://www.youtube.com/embed/".concat(youtubeId),
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  })
});

export default YoutubeLink;